module.exports = __webpack_public_path__ + "img/min-max.2bc39d62.svg";